module.exports = __webpack_public_path__ + "img/chat-dots-fill.be75b2fc.svg";